// Google Forms service — no API key required.
// The attendance register form is a manually created Google Form;
// its share URL is stored in REACT_APP_GOOGLE_FORMS_ATTENDANCE_URL.

const googleFormsService = {
  getAttendanceFormUrl() {
    return process.env.REACT_APP_GOOGLE_FORMS_ATTENDANCE_URL || '';
  },

  isConfigured() {
    return Boolean(process.env.REACT_APP_GOOGLE_FORMS_ATTENDANCE_URL);
  },
};

export default googleFormsService;
